import store from "../store/store";

export default function (to, from, next) {
    if(store.getters.isAuthenticated) next(); else next("/error404")
}